import React from 'react';
import moment from 'moment';
import { I18n } from '@aws-amplify/core';

import * as S from './styles';

interface ActionPlanData {
	task_id: string;
	task_name: string;
	responsible: string;
	deadline: string;
	description: string;
	subtasks: {
		task_type: string;
		responsible: string;
		date: string;
	}[];
}

interface ActionPlanProps {
	data: ActionPlanData;
}

export function ActionPlan({ data }: ActionPlanProps): JSX.Element {
	return (
		<div style={{ marginBottom: '24px', marginTop: '24px' }}>
			<S.ActionPlanTitle>{I18n.get('Action Plan')}</S.ActionPlanTitle>

			<S.ActionPlanContainer>
				<S.TaskHeader>
					<h4 style={{ margin: 0, fontSize: '16px', fontWeight: '600', color: '#333' }}>{data.task_name}</h4>
				</S.TaskHeader>

				<S.TaskDetails>
					<S.DetailRow>
						<S.DetailLabel>{I18n.get('Responsible')}:</S.DetailLabel>
						<S.DetailValue>{data.responsible}</S.DetailValue>
					</S.DetailRow>
					<S.DetailRow>
						<S.DetailLabel>{I18n.get('Deadline')}:</S.DetailLabel>
						<S.DetailValue>
							{data.deadline ? moment(data.deadline).format('DD/MM/YYYY') : '-'}
						</S.DetailValue>
					</S.DetailRow>
					<S.DetailRow>
						<S.DetailLabel>{I18n.get('Description')}:</S.DetailLabel>
						<S.DetailValue>{data.description}</S.DetailValue>
					</S.DetailRow>
				</S.TaskDetails>

				<S.TasksHeader>
					<h4 style={{ margin: 0, fontSize: '16px', fontWeight: '600', color: '#333' }}>
						{I18n.get('Tasks')}
					</h4>
				</S.TasksHeader>

				<S.TasksTable>
					<tbody>
						{data.subtasks.map((subtask, index) => (
							<tr key={index}>
								<td>{subtask.task_type}</td>
								<td>{subtask.responsible}</td>
								<td>{subtask.date ? moment(subtask.date).format('DD/MM/YYYY') : '-'}</td>
							</tr>
						))}
					</tbody>
				</S.TasksTable>
			</S.ActionPlanContainer>
		</div>
	);
}
